import React, { useContext, useEffect, useState } from "react";
import { Loader, PdfViewer } from "../../components";
import { HRPOLICYPAYROLL, BASE_URL } from "../../Constants";
import ApiCallTwo from "../../utils/ApiCallTwo";
import AuthContext from "../../contexts/AuthContext";

const Hrpolicy = () => {
	const { authTokens } = useContext(AuthContext);
	const [pdfUrl, setPdfUrl] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		fetchData();
	}, []);

	const fetchData = async () => {
		try {
			const response = await ApiCallTwo(
				HRPOLICYPAYROLL,
				"GET",
				authTokens,
				null
			);

			if (response.isPdf) {
				const pdfBlob = response.data;
				//console.log("hrpolicys", pdfBlob);
				const url = URL.createObjectURL(pdfBlob);
				setPdfUrl(url);
				setIsLoading(false);
			}
		} catch (error) {
			console.log("Error fetching PDF data", error);
			setIsLoading(false);
		}
	};
	return (
		<div className="w-auto my-6 flex flex-col mx-6 py-4 px-2 justify-center">
			<h2 className="text-lg mx-2 intro-x table-body-td px-2 font-semibold mb-4">
				HR Policy
			</h2>
			<div className="w-auto intro-y flex justify-center items-center py-4 px-2">
				{isLoading ? (
					<div className="w-full h-[70vh] flex items-center justify-center">
						<Loader />
					</div>
				) : (
					PdfViewer && <PdfViewer pdfUrl={pdfUrl} />
				)}
			</div>
		</div>
	);
};

export default Hrpolicy;
